var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-label-container"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('g-required-icon',{staticClass:"required"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }